import { z } from 'zod';

const size = z.object({ width: z.number(), depth: z.number(), height: z.number() });

/**
 * Extracted on upload by the server. `size` is already converted to model axes
 * (width = glTF x, depth = glTF z, height = glTF y), assuming 1 glTF unit = 1 m.
 */
export const glbMetadataSchema = z.object({
  size,
  triangles: z.number().int(),
  meshes: z.number().int(),
  textures: z.number().int(),
  extensions: z.array(z.string()),
});
export type GlbMetadata = z.infer<typeof glbMetadataSchema>;

export const assetDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  kind: z.enum(['GLB', 'IMAGE', 'THUMBNAIL', 'REPORT']),
  sizeBytes: z.number().int(),
  /** null = system library asset. */
  ownerId: z.string().nullable(),
  createdAt: z.string(),
  metadata: glbMetadataSchema,
});
export type AssetDto = z.infer<typeof assetDtoSchema>;

export const assetListResponseSchema = z.object({ assets: z.array(assetDtoSchema) });
export const assetResponseSchema = z.object({ asset: assetDtoSchema });

/** Uploaded site plan / aerial photo; pixel size is read from the file header. */
export const imageAssetDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  width: z.number().int(),
  height: z.number().int(),
});
export type ImageAssetDto = z.infer<typeof imageAssetDtoSchema>;
export const imageResponseSchema = z.object({ image: imageAssetDtoSchema });

export const assetUsageResponseSchema = z.object({
  projects: z.array(z.object({ id: z.string(), name: z.string() })),
});

export const MAX_ASSET_NAME_LENGTH = 120;
